import { Adapter as r, getAdapter as t } from "../../adapter.js";
import { CheckoutModel as o } from "./checkout.model.js";
import { CheckoutDesignAdapter as p } from "./design/design.adapter.js";
import { CheckoutSettingsAdapter as d } from "./settings/settings.adapter.js";
class g extends r {
  adapt(e) {
    return new o({
      design: t(p).adapt(e.design),
      settings: t(d).adapt(e.settings)
    });
  }
  serialize(e) {
  }
}
export {
  g as CheckoutAdapter
};
//# sourceMappingURL=checkout.adapter.js.map
